var current_locale_code = $('html').attr('lang');
if(current_locale_code == 'de'){
  var current_locale_code = 'de_CH';
}

function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
var isWoman = false;
if(window.location.href.indexOf("frauen") > -1) {
  isWoman = true;
  $('.season-wrapper .schedule-top .schedule-btn').attr('href','http://cal.ae/ushiiiw');
  //$('.season-wrapper .schedule-top .schedule-btn').removeAttr('target');
  // $('.season-wrapper .schedule-top .schedule-btn').attr('title','Der Spielplan für die FC Zürich Frauen für den Kalender (Outlook/Apple/Google) wird in kürze verfügbar sein');
  //$('.season-wrapper .schedule-top .schedule-btn').addClass('tooltip bottom-tooltip');
  //$('.season-wrapper .schedule-top .schedule-btn').prepend('<span class="tooltiptext">Der Spielplan für die FC Zürich Frauen für den Kalender (Outlook/Apple/Google) wird in kürze verfügbar sein</span>');
}

var gender = 'MEN';

if(isWoman == true){
  gender = 'WOMEN'; 
  $('.spielplan-wrapper .spielplan-gallary-wrapper').remove();
  $('.schedule-wrapper .button--zur-table').attr('href','/pages/tabelle-frauen');
}
 
// custom translation
//var currentLang = $('input[name="locale_code"]').val();
/*let lang = 0;
if(currentLang == 'de'){
   lang = 0;
} 
else if(currentLang == 'en'){
   lang = 1;
}
else if(currentLang == 'fr'){
   lang = 2;
} */
var last_game = [ "LETZTES SPIEL","Last Game","Dernier Match" ];
var next_game = [ "NÄCHSTES SPIEL","Next Game","Prochain Match" ];
var round = [ "Runde","Round","Round" ];
var not_fixed = [ "NOCH NICHT DEFINITIV FIXIERT","NOT YET DEFINITELY SCHEDULED","PAS ENCORE DÉFINITIVEMENT FIXÉ" ];

var championship = [ "MEISTERSCHAFT","CHAMPIONSHIP","CHAMPIONNAT" ];
var international = [ "INTERNATIONAL","INTERNATIONAL","INTERNATIONAL" ];
var swiss_cup = [ "SCHWEIZER CUP","SWISS CUP","COUPE DE SUISSE" ];
var test_matches = [ "TESTSPIELE","TEST MATCHES","MATCHES D'ESSAI" ];
var meisterschaft_awsl = [ "Meisterschaft AWSL","CHAMPIONSHIP AWSL","CHAMPIONNAT AWSL" ];
var gegner_noch_offen = ['GEGNER NOCH OFFEN','OPPONENT NOT YET DETERMINED', 'ADVERSAIRE ENCORE À DÉTERMINER'];

//console.log(last_game[lang],next_game[lang]);
  var settings = {
    "url": API_URL + "match-center/soccer-seasons",
    "method": "GET",
    "timeout": 0,
    "headers": {
      "Authorization": AUTH
    },
  };
  
  $.ajax(settings).done(function (response) {
    var data = response.data;
    var current_year;
    if(data != null){
      var seasonOptions = '';
      for(let a=0; a<data.length;a++){
        if(getParameterByName('season') == data[a].name){
          var selected = 'selected';
          var q = getParameterByName('season');
        }else if(data[a].isCurrent == true && getParameterByName('season') == null){
          var selected = 'selected';
          var q = data[a].name;
        }else{
          var selected = '';
        }
        if(data[a].isCurrent == true){
          current_year = data[a].name;
        }

        seasonOptions += '<option value="'+data[a].name+'" '+selected+'>'+data[a].name+'</option>'
      }
      $('#id_season').html(seasonOptions);
      var currentUrl = $('.spielplan_load_all .button--spielplan').attr('href');
      console.log('currentUrl',currentUrl)
      if(currentUrl.indexOf('http')>-1){
        var url = new URL(currentUrl);
        url.searchParams.set("season", current_year); // setting your param
        var newUrl = url.href; 
        if(currentUrl.indexOf('season')>-1){
          $('.spielplan_load_all .button--spielplan').attr('href',newUrl);
        }
      }

    }
 
/*if(getParameterByName('season') == null){
  var q = current_year;
}else{
  var q = getParameterByName('season');
  
  var league = getParameterByName('league');
  
  if(league!= null && league!='all' ){
    var q = q.concat('&filter[soccerLeague.id]='+league);
  }
  
  $('.season-wrapper #id_season option').attr("selected",false);

  $('.season-wrapper #id_season option').each(function(){
    if(getParameterByName('season') == $(this).attr("value")){
      $('.season-wrapper #id_season option[value="'+getParameterByName('season')+'"').attr("selected",true);
    }
  });
}*/

var league = getParameterByName('league');
var season_year = q;
    
if(league!= null && league!='all' ){
  var q = q.concat('&filter[soccerLeague.id][]='+league);
}
var location_url = window.location.href,
    parts = location_url.split("/"),
    last_part = parts[parts.length - 1];

if(last_part == 'spielplan' || last_part == 'frauen') {

  // var url = "https://app.aico.swiss/19838/api/v1/aico-matches?filter[season.name]="+q+"&filter[isLightVersion]=true&filter[isUpcoming]=true&filter[gender]="+gender;
  var url = API_URL + 'match-center/soccer-matches?filter[isUpcoming]=true&filter[type]='+gender+'&isDetailed=false&filter[season.name][]='+q

  var settings = {
  "url": url,
  "method": "GET",
  "timeout": 0,
  "headers": {
    "Authorization": AUTH,
    "Content-Type": "application/json"
  }
};

$.ajax(settings).done(function (response) {
  console.log('one');
  var matchDay = response.data;

  // console.log(matchDay);
  var data = response.data;
  var html = '';
  var html_next = '';
  var result = data.reduce(function (r, a) {
        r[monthyear(a.date)] = r[monthyear(a.date)] || [];
        r[monthyear(a.date)].push(a);
        return r;
    }, Object.create(null));
  
  
  if(jQuery.isEmptyObject(result)){
    html_next += '<div class="center"><h3 class="section-subtitle">Keine nächsten Spiele vorhanden.</h3></div>';
  }
  var d2 = new Date();
  
  var Last_matchid = $('.spielplan-wrapper #last-men-match-id').attr("value");
  var Next_matchid = $('.spielplan-wrapper #next-men-match-id').attr("value"); 

  if(isWoman == true){
   var Last_matchid = $('.spielplan-wrapper #last-women-match-id').attr("value");
   var Next_matchid = $('.spielplan-wrapper #next-women-match-id').attr("value"); 
  }
  
 //console.log("fetch it",Last_matchid,Next_matchid,isWoman);
  var aaa = 0;
  const monthNames = ["Januar", "Februar", "März", "April", "Mai", "Juni",
    "Juli", "August", "September", "Oktober", "November", "Dezember"];
  
  var sortedEntries = Object.entries(result).sort((a, b) => {
    let [monthA, yearA] = a[0].split(' ');
    let [monthB, yearB] = b[0].split(' ');

    return yearA - yearB || monthNames.indexOf(monthA) - monthNames.indexOf(monthB);
  }); 
  
  $.each(sortedEntries, function (index, entry) {
    let key = entry[0];
    let matchDay = entry[1];
    
    html_next += '<h3 class="section-subtitle '+handleize(key)+'">'+key+'</h3>';
    for( var mp = 0; mp<matchDay.length; mp++){
      aaa++;
      
      var iSNP = false;
      var isnV = false;
      var scoreClass = '';
      
      var matchdata = matchDay[mp];
      var regularTimeHome = matchdata.regularTimeHome;
      var regularTimeGuest = matchdata.regularTimeGuest;
      var halfTimeHome = matchdata.halfTimeHome;
      var halfTimeGuest = matchdata.halfTimeGuest;
      var newDate = matchdata.date.split(' ');
      var newTime = newDate[1].split(':');
      var date = newDate[0]+'T'+newDate[1]+'Z';
      var d1 = new Date(date);
      var match_id = matchDay[mp].id;

      if(match_id == Last_matchid){
        var match_class = "last-match-block";
      } else if(match_id == Next_matchid){
        var match_class = "next-match-block";
      } else {
        var match_class = "";
      }

      if(aaa == 1){
        var match_class = "next-match-block";
      }
       
      html_next += '<div class="match-block '+match_class+'" data-id="'+matchDay[mp].id+'">';
      html_next += '<div class="match-main-inner">';
     
      html_next += '<div class="match-date-wrapper">';     
      if(match_class == 'last-match-block'){
        html_next += '<div class="match-highlight">'+ last_game[lang] +'</div>';
      } else if(match_class == 'next-match-block'){
        html_next += '<div class="match-highlight">'+ next_game[lang] +'</div>';
      } else {} 
      html_next += '<div class="date">'+formatDateStringWithMonth(matchdata.date)+'</div>';
      html_next += '<div class="match-type">';
      if(matchdata.soccerLeague != null ){
        if(matchdata.soccerLeague.translations[0].name == 'Championship'){
          html_next += '<span class="match-Championship">'+championship[lang]+'</span>';
        }else if(matchdata.soccerLeague.translations[0].name == 'Test matches'){
          html_next += '<span class="match-Championship">'+test_matches[lang]+'</span>';
        }else if(matchdata.soccerLeague.translations[0].name == 'UEFA Frauen Champions League'){
          html_next += "<span class='match-Championship'>UEFA Women's Champions League</span>";
        }else{
            var soccerLeague_name = "";
            if(matchdata.soccerLeague.translations[0].name == 'Meisterschaft'){
              soccerLeague_name = championship[lang];
            } else if(matchdata.soccerLeague.translations[0].name == 'International') {
              soccerLeague_name = international[lang];
            } else if(matchdata.soccerLeague.translations[0].name == 'Schweizer Cup') {
              soccerLeague_name = swiss_cup[lang];
            } else if(matchdata.soccerLeague.translations[0].name == 'Testspiele') {
              soccerLeague_name = test_matches[lang];
            } else if(matchdata.soccerLeague.translations[0].name == 'Meisterschaft AWSL') {
              soccerLeague_name = meisterschaft_awsl[lang];
            } 
            else {
              soccerLeague_name = matchdata.soccerLeague.translations[0].name;
            }
          html_next += '<span class="match-Championship">'+soccerLeague_name+'</span>' ;
        }
      }

      if(matchdata.soccerLeague != null && ((matchdata.soccerMatchDay != null && matchdata.soccerMatchDay != '') || (matchdata.deprecatedSoccerMatchDay != null && matchdata.deprecatedSoccerMatchDay!= ''))){
        html_next += '<span>, </span>';
      }
      
      if(matchdata.soccerMatchDay != null && matchdata.soccerMatchDay != ''){
        html_next += '<span class="match-matchDay">'+round[lang]+' '+matchdata.soccerMatchDay+'</span>';  
      }else if(matchdata.deprecatedSoccerMatchDay != null && matchdata.deprecatedSoccerMatchDay!= ''){
        html_next += '<span class="match-matchDay">'+round[lang]+' '+matchdata.deprecatedSoccerMatchDay+'</span>';
      }
      if(matchdata.isConfirmed == false){
        html_next += '<p class="match-not-confirmed">'+not_fixed[lang]+'</p>';
      }
      
      html_next += '</div>';
      html_next += '</div>';
      html_next += '<div class="match-wrapper-inner">';
      html_next += '<div class="team-1">';
      
      if(matchdata.homeClub != null){
        html_next += '<div class="team-img">';
        html_next += '<img srcset="'+matchdata.homeClub.logo+'" alt="" loading="lazy">';
        html_next += '</div>';  
        html_next += '<h2 class="team-name">'+matchdata.homeClub.name+'</h2>';
      }        
   
      html_next += '</div>';
      html_next += '<div class="team-score-wrapper">';
      if((regularTimeHome == null && regularTimeGuest == null) && (matchdata.status == 'NOT STARTED' || matchdata.status == 'ABORTED' || matchdata.status == '') ){
      	var score = 'VS';
      }
      else {
        if((matchdata.atForfeitHome != null && matchdata.atForfeitGuest != null) && (matchdata.atForfeitHome != 0 && matchdata.atForfeitGuest != 0) ){
          regularTimeHome = matchdata.atForfeitHome;
          regularTimeGuest = matchdata.atForfeitGuest;
          scoreClass = 'hidden';
        }else if((matchdata.penaltyShootoutHome != null && matchdata.penaltyShootoutGuest != null) && (matchdata.penaltyShootoutHome != 0 && matchdata.penaltyShootoutGuest != 0)){
          regularTimeHome = matchdata.penaltyShootoutHome;
          regularTimeGuest = matchdata.penaltyShootoutGuest;
          iSNP = true;
          scoreClass = 'hidden';
        }else if((matchdata.extraTimeHome != null && matchdata.extraTimeGuest != null) && (matchdata.extraTimeHome != 0 && matchdata.extraTimeGuest != 0)){
          regularTimeHome = matchdata.extraTimeHome;
          regularTimeGuest = matchdata.extraTimeGuest;
          isnV = true;
          scoreClass = 'hidden';
          // console.log('extra',matchDay[mp].id)
        }
        else if (matchdata.regularTimeHome != null && matchdata.regularTimeGuest != null){
          regularTimeHome = matchdata.regularTimeHome;
          regularTimeGuest = matchdata.regularTimeGuest;
        }
         var score = regularTimeHome+':'+regularTimeGuest;
      }
      /*if(matchdata.status == 'FIRST HALF'){
        if(matchdata.halfTimeHome == null && matchdata.halfTimeGuest == null){
          score = 'VS';
        }
        else if (matchdata.regularTimeHome != null && matchdata.regularTimeGuest != null){
          score = matchdata.regularTimeHome +':'+matchdata.regularTimeGuest;
        }
        else{
          score = halfTimeHome+':'+halfTimeGuest;
        }
        if(matchdata.regularTimeHome == null && matchdata.regularTimeGuest==null){
          var scoreClass = 'hidden';
        }
      }*/
      if(matchdata.status == 'FIRST HALF'){
        
        if((matchdata.regularTimeHome == null && matchdata.regularTimeGuest == null) && (matchdata.halfTimeHome == null && matchdata.halfTimeGuest == null)){
          score = '0:0';
        }
        else if(matchdata.halfTimeHome == null && matchdata.halfTimeGuest != null){
          score = '0:'+matchdata.halfTimeGuest;
        }
        else if(matchdata.halfTimeHome != null && matchdata.halfTimeGuest == null){
          score = matchdata.halfTimeHome + ':0';
        }
        else if(matchdata.regularTimeHome != null && matchdata.regularTimeGuest!=null){
          score = matchdata.regularTimeHome+':'+matchdata.regularTimeGuest;
        }
        else{
          score = matchdata.halfTimeHome+':'+matchdata.halfTimeGuest;
        }
        if(matchdata.regularTimeHome == null && matchdata.regularTimeGuest==null){
          var scoreClass = 'hidden';
        }
      }
      if(matchdata.status == 'SECOND HALF'){
        
        if((matchdata.regularTimeHome == null && matchdata.regularTimeGuest == null) && (matchdata.halfTimeHome == null && matchdata.halfTimeGuest == null)){
          score = '0:0';
        }
        else if(matchdata.halfTimeHome == null && matchdata.halfTimeGuest != null){
          score = '0:'+matchdata.halfTimeGuest;
        }
        else if(matchdata.halfTimeHome != null && matchdata.halfTimeGuest == null){
          score = matchdata.halfTimeHome + ':0';
        }
        else if(matchdata.regularTimeHome != null && matchdata.regularTimeGuest!=null){
          score = matchdata.regularTimeHome+':'+matchdata.regularTimeGuest;
        }
        else if(matchdata.regularTimeHome == null && matchdata.regularTimeGuest != null){
          score = matchdata.halfTimeHome+':'+matchdata.regularTimeGuest;
        }
        else if(matchdata.regularTimeHome != null && matchdata.regularTimeGuest==null){
          score = matchdata.regularTimeHome+':'+matchdata.halfTimeGuest;
        }
        else{
          score = matchdata.halfTimeHome+':'+matchdata.halfTimeGuest;
        }
        if(matchdata.regularTimeHome == null && matchdata.regularTimeGuest==null){
          var scoreClass = 'hidden';
        }
      }

      if((regularTimeHome == null && regularTimeGuest == null) && matchdata.halfTimeHome != null && matchdata.halfTimeGuest != null ){
        score = halfTimeHome+':'+halfTimeGuest;
      }
      if(match_id == Last_matchid && score == 'VS'){
        score = '0:0';
        halfTimeHome = 0;
        halfTimeGuest = 0;
      }

      if(matchdata.status == 'DEFERRED' || matchdata.status == 'ABORTED' || matchdata.status == 'INTERRUPTED'){ 
      score = 'VS'; 
      scoreClass = 'hidden';          
      }
  
      html_next += '<div class="team-score">'+score+'</div>';
      if(halfTimeHome != null && halfTimeGuest != null){
    	html_next += '<div class="team-time '+scoreClass+'">('+halfTimeHome+':'+halfTimeGuest+')</div>';
      }
      if(iSNP == true){
        html_next += '<div class="team-time">n.P.</div>';
      }else if(isnV == true){
        html_next += '<div class="team-time">n.V.</div>';
      }
      html_next += '</div>';
      html_next += '<div class="team-2">';
     
      if(matchdata.guestClub != null){
        var guest_team_name = matchdata.guestClub.name;
        if(guest_team_name == 'Gegner noch offen'){
          guest_team_name = gegner_noch_offen[lang];
        }
         html_next += '<div class="team-img">';
         html_next += '<img srcset="'+matchdata.guestClub.logo+'" alt="" loading="lazy">';
         html_next += '</div>';
         html_next += '<h2 class="team-name">'+guest_team_name+'</h2>';
      }
     
      
      html_next += '</div>';
      html_next += '</div>';
      
    
        // console.log(matchDay[mp].id,d1,d2);
        if((d1<=d2) ){
      
              html_next += '<div class="button-wrapper">';
                html_next += '<a href="/pages/matchcenter/'+matchDay[mp].id+'" class="button button--primary download">';
                  html_next += '<span>';
                    html_next += '<svg xmlns="http://www.w3.org/2000/svg" width="28.087" height="28.087" viewBox="0 0 28.087 28.087">';
                      html_next += '<path id="Icon_ionic-ios-football" data-name="Icon ionic-ios-football" d="M17.419,3.375A14.044,14.044,0,1,0,31.462,17.419,14.041,14.041,0,0,0,17.419,3.375Zm8.595,5.449A12.059,12.059,0,0,1,27.54,10.68a.247.247,0,0,1,.027.236l-.972,2.788a.268.268,0,0,1-.142.155L22.57,15.629a.272.272,0,0,1-.284-.041l-3.821-3.214a.277.277,0,0,1-.095-.209V7.905a.27.27,0,0,1,.122-.223L21.085,5.92a.266.266,0,0,1,.236-.034A12.3,12.3,0,0,1,26.014,8.824Zm-4.99,20.093a.249.249,0,0,1-.176.162,12.136,12.136,0,0,1-3.43.486,12.347,12.347,0,0,1-3.43-.486.28.28,0,0,1-.176-.162l-1.107-2.9a.283.283,0,0,1,.014-.223l1.506-2.856a.273.273,0,0,1,.236-.142h5.908a.265.265,0,0,1,.236.142l1.506,2.856a.283.283,0,0,1,.014.223Zm-4.551-21v4.26a.277.277,0,0,1-.095.209L12.551,15.6a.272.272,0,0,1-.284.041L8.385,13.867a.266.266,0,0,1-.142-.155L7.271,10.93a.264.264,0,0,1,.027-.236,12.241,12.241,0,0,1,6.225-4.78.266.266,0,0,1,.236.034L16.352,7.71A.223.223,0,0,1,16.473,7.919ZM5.38,17.966l2.437-2.107a.27.27,0,0,1,.29-.041l3.538,1.607a.27.27,0,0,1,.149.182l.986,3.869a.323.323,0,0,1-.02.2l-1.566,2.964a.263.263,0,0,1-.243.142l-3.106-.041a.282.282,0,0,1-.216-.108,12.067,12.067,0,0,1-2.343-6.441A.3.3,0,0,1,5.38,17.966ZM23.637,24.63l-1.56-2.957a.248.248,0,0,1-.02-.2l.986-3.869a.27.27,0,0,1,.149-.182l3.538-1.607a.284.284,0,0,1,.29.041l2.437,2.107a.273.273,0,0,1,.095.223,12.031,12.031,0,0,1-2.343,6.441.262.262,0,0,1-.216.108l-3.113.041A.3.3,0,0,1,23.637,24.63Z" transform="translate(-3.375 -3.375)" fill="#fff"></path>';
                      html_next += '</svg>';
                     //html_next += '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="20" viewBox="0 0 15 20">';
                      //html_next += '<path id="Icon_awesome-file-download" data-name="Icon awesome-file-download" d="M8.75,5.313V0H.938A.935.935,0,0,0,0,.938V19.063A.935.935,0,0,0,.938,20H14.063A.935.935,0,0,0,15,19.063V6.25H9.688A.94.94,0,0,1,8.75,5.313Zm2.986,8.256L7.97,17.307a.666.666,0,0,1-.939,0L3.264,13.569A.625.625,0,0,1,3.7,12.5H6.25V9.375a.625.625,0,0,1,.625-.625h1.25a.625.625,0,0,1,.625.625V12.5H11.3A.625.625,0,0,1,11.736,13.569ZM14.727,4.1,10.9.273A.937.937,0,0,0,10.238,0H10V5h5V4.762A.935.935,0,0,0,14.727,4.1Z" fill="#ae9357"/>';
                    //html_next += '</svg>';
                  html_next += '</span>';
                  //html_next += 'DOWNLOAD';
                html_next += '</a>';
              html_next += '</div>';
            
        }
      //}
      html_next += '</div>';
      html_next += '<div class="match-ticket-wrapper">';
        // if(mp > 0){
      if((matchdata.ticketsUrl != null && matchdata.ticketsUrl != "") && d1>d2 ){
        html_next += '<a href="'+matchdata.ticketsUrl+'" target="_blank" class="link link-ticket">';
          html_next += '<span><svg xmlns="http://www.w3.org/2000/svg" width="30.604" height="20.402" viewBox="0 0 30.604 20.402">';
            html_next += '<path id="Icon_awesome-ticket-alt" data-name="Icon awesome-ticket-alt" d="M6.8,9.6h17V19.8H6.8Zm21.252,5.1a2.55,2.55,0,0,0,2.55,2.55v5.1a2.55,2.55,0,0,1-2.55,2.55H2.55A2.55,2.55,0,0,1,0,22.352v-5.1a2.55,2.55,0,0,0,0-5.1V7.05A2.55,2.55,0,0,1,2.55,4.5h25.5A2.55,2.55,0,0,1,30.6,7.05v5.1A2.55,2.55,0,0,0,28.053,14.7ZM25.5,9.176A1.275,1.275,0,0,0,24.228,7.9H6.376A1.275,1.275,0,0,0,5.1,9.176V20.227A1.275,1.275,0,0,0,6.376,21.5H24.228A1.275,1.275,0,0,0,25.5,20.227Z" transform="translate(0 -4.5)" fill="#fff"/>';
          html_next += '</svg></span>';
          html_next += 'TICKETS';
        html_next += '</a>';
        
        if(matchdata.showHospitality == 1 && d1>d2 && matchdata.homeClub.shortName == 'FCZ'){
          var hospility_link = '/pages/hospitalityangebote';
          if(matchDay[mp].id == '6419'){
            hospility_link = 'https://fcz.eventim-inhouse.de/webshop/webticket/shop?event=73&kassierer=webvip'
          }else if(matchDay[mp].id == '6416'){
            hospility_link = 'https://fcz.eventim-inhouse.de/webshop/webticket/shop?event=74&kassierer=webvip'
          }else if(matchDay[mp].id == '6413'){
            hospility_link = 'https://fcz.eventim-inhouse.de/webshop/webticket/shop?event=75&kassierer=webvip'
          }else if(matchDay[mp].id == '6410'){
            hospility_link = 'https://fcz.eventim-inhouse.de/webshop/webticket/shop?event=76&kassierer=webvip'
          }else if(matchDay[mp].id == '6408'){
            hospility_link = 'https://fcz.eventim-inhouse.de/webshop/webticket/shop?event=77&kassierer=webvip'
          }
          html_next += '<a href="'+hospility_link+'" target="_blank" class="link link-hospitality">';
            html_next += '<span><svg xmlns="http://www.w3.org/2000/svg" width="14.063" height="25.001" viewBox="0 0 14.063 25.001">';
              html_next += '<path id="Icon_awesome-wine-glass" data-name="Icon awesome-wine-glass" d="M10.547,22.657H8.594V16.935a7.063,7.063,0,0,0,5.44-7.528L13.255.71A.775.775,0,0,0,12.488,0H1.575A.774.774,0,0,0,.809.71l-.779,8.7a7.063,7.063,0,0,0,5.44,7.528v5.722H3.516A1.953,1.953,0,0,0,1.563,24.61.391.391,0,0,0,1.953,25H12.11a.391.391,0,0,0,.391-.391A1.953,1.953,0,0,0,10.547,22.657Z" transform="translate(0)" fill="#fff"/>';
            html_next += '</svg></span>';
            html_next += 'HOSPITALITY';
          html_next += '</a>';
        }
        }
      if(matchdata.presaleStartDate != null){
        html_next += '<a href="" class="link link-start-date">';
          html_next += 'VORVERKAUF STARTET '+matchdata.presaleStartDate+' UHR';
        html_next += '</a>';
      }
      html_next += '</div>';
      html_next += '</div>';
    }
   
  });
  
  

  // var url_old = "https://app.aico.swiss/19838/api/v1/aico-matches?filter[season.name]="+q+"&filter[isLightVersion]=true&filter[isUpcoming]=false&page[size]=5&filter[gender]="+gender;
  var url_old = API_URL + 'match-center/soccer-matches?filter[isUpcoming]=false&filter[type]='+gender+'&isDetailed=false&page[number]=0&page[size]=5&filter[season.name][]='+q;
  var settings_old = {
  "url": url_old,
  "method": "GET",
  "timeout": 0,
  "headers": {
    "Authorization": AUTH,
    "Content-Type": "application/json"
  }
  };
 
  $.ajax(settings_old).done(function (response) {
  //console.log(response);
    console.log('two');
  var matchDay = response.data;
  var data = response.data;
  
  var result = data.reduce(function (r, a) {
        r[monthyear(a.date)] = r[monthyear(a.date)] || [];
        r[monthyear(a.date)].push(a);
        return r;
    }, Object.create(null));  
  
  if(jQuery.isEmptyObject(result)){
    // html += '<div class="center"><h3 class="section-subtitle">Keine Spiele vorhanden.</h3></div>';
  }
  var d2 = new Date();  

  
  var Last_matchid = $('.spielplan-wrapper #last-men-match-id').attr("value");
  var Next_matchid = $('.spielplan-wrapper #next-men-match-id').attr("value"); 

  if(isWoman == true){
   var Last_matchid = $('.spielplan-wrapper #last-women-match-id').attr("value");
   var Next_matchid = $('.spielplan-wrapper #next-women-match-id').attr("value"); 
  }
  
    // console.log("fetch it",Last_matchid,Next_matchid,isWoman);
  
    
    for( var mp = matchDay.length - 1; mp >= 0; --mp){
     // console.log(mp,matchDay[mp].id);

      var iSNP = false;
      var isnV = false;
      var scoreClass = '';
      
      var matchdata = matchDay[mp];
      var regularTimeHome = matchdata.regularTimeHome;
      var regularTimeGuest = matchdata.regularTimeGuest;
      var halfTimeHome = matchdata.halfTimeHome;
      var halfTimeGuest = matchdata.halfTimeGuest;
      var newDate = matchdata.date.split(' ');
      var newTime = newDate[1].split(':');
      var date = newDate[0]+'T'+newDate[1]+'Z';
      var d1 = new Date(date);
      var match_id = matchDay[mp].id;

      

      if(mp == 0){
        var match_class = "last-match-block";
      } else if(match_id == Next_matchid){
        var match_class = "next-match-block";
      } else {
        var match_class = "";
      }
       
      html += '<div class="match-block '+match_class+'" data-id="'+matchDay[mp].id+'">';
      html += '<div class="match-main-inner">';
     
      html += '<div class="match-date-wrapper">';     
      if(match_class == 'last-match-block'){
        html += '<div class="match-highlight">'+ last_game[lang] +'</div>';
      } else if(match_class == 'next-match-block'){
        html += '<div class="match-highlight">'+ next_game[lang] +'</div>';
      } else {} 
      html += '<div class="date">'+formatDateStringWithMonth(matchdata.date)+'</div>';
      html += '<div class="match-type">';
      if(matchdata.soccerLeague != null ){
        if(matchdata.soccerLeague.translations[0].name == 'Championship'){
          html += '<span class="match-Championship">'+championship[lang]+'</span>';
        }else if(matchdata.soccerLeague.translations[0].name == 'Test matches'){
          html += '<span class="match-Championship">'+test_matches[lang]+'</span>';
        }else if(matchdata.soccerLeague.translations[0].name == 'UEFA Frauen Champions League'){
          html += "<span class='match-Championship'>UEFA Women's Champions League</span>";
        }else{
            var soccerLeague_name = "";
            if(matchdata.soccerLeague.translations[0].name == 'Meisterschaft'){
              soccerLeague_name = championship[lang];
            } else if(matchdata.soccerLeague.translations[0].name == 'International') {
              soccerLeague_name = international[lang];
            } else if(matchdata.soccerLeague.translations[0].name == 'Schweizer Cup') {
              soccerLeague_name = swiss_cup[lang];
            } else if(matchdata.soccerLeague.translations[0].name == 'Testspiele') {
              soccerLeague_name = test_matches[lang];
            } else if(matchdata.soccerLeague.translations[0].name == 'Meisterschaft AWSL') {
              soccerLeague_name = meisterschaft_awsl[lang];
            }
            else {
              soccerLeague_name = matchdata.soccerLeague.translations[0].name;
            }
          html += '<span class="match-Championship">'+soccerLeague_name+'</span>' ;
        }
      }

      if(matchdata.soccerLeague != null && ((matchdata.soccerMatchDay != null && matchdata.soccerMatchDay != '') || (matchdata.deprecatedSoccerMatchDay != null && matchdata.deprecatedSoccerMatchDay!= ''))){
        html += '<span>, </span>';
      }
      
      if(matchdata.soccerMatchDay != null && matchdata.soccerMatchDay != ''){
        html += '<span class="match-matchDay">'+round[lang]+' '+matchdata.soccerMatchDay+'</span>';  
      }else if(matchdata.deprecatedSoccerMatchDay != null && matchdata.deprecatedSoccerMatchDay!= ''){
        html += '<span class="match-matchDay">'+round[lang]+' '+matchdata.deprecatedSoccerMatchDay+'</span>';
      }
      if(matchdata.isConfirmed == false){
        html += '<p class="match-not-confirmed">'+not_fixed[lang]+'</p>';
      }
      
      html += '</div>';
      html += '</div>';
      html += '<div class="match-wrapper-inner">';
      html += '<div class="team-1">';
      
      if(matchdata.homeClub != null){
        html += '<div class="team-img">';
        html += '<img srcset="'+matchdata.homeClub.logo+'" alt="" loading="lazy">';
        html += '</div>';  
        html += '<h2 class="team-name">'+matchdata.homeClub.name+'</h2>';
      }        
   
      html += '</div>';
      html += '<div class="team-score-wrapper">';
      if((regularTimeHome == null && regularTimeGuest == null) && (matchdata.status == 'NOT STARTED' || matchdata.status == 'ABORTED' || matchdata.status == '') ){
      	var score = 'VS';
      }
      else {
        if((matchdata.atForfeitHome != null && matchdata.atForfeitGuest != null) && (matchdata.atForfeitHome != 0 && matchdata.atForfeitGuest != 0) ){
          regularTimeHome = matchdata.atForfeitHome;
          regularTimeGuest = matchdata.atForfeitGuest;
          scoreClass = 'hidden';
        }else if((matchdata.penaltyShootoutHome != null && matchdata.penaltyShootoutGuest != null) && (matchdata.penaltyShootoutHome != 0 && matchdata.penaltyShootoutGuest != 0)){
          regularTimeHome = matchdata.penaltyShootoutHome;
          regularTimeGuest = matchdata.penaltyShootoutGuest;
          iSNP = true;
          scoreClass = 'hidden';
        }else if((matchdata.extraTimeHome != null && matchdata.extraTimeGuest != null) && (matchdata.extraTimeHome != 0 && matchdata.extraTimeGuest != 0)){
          regularTimeHome = matchdata.extraTimeHome;
          regularTimeGuest = matchdata.extraTimeGuest;
          isnV = true;
          scoreClass = 'hidden';
          // console.log('extra',matchDay[mp].id)
        }
        else if (matchdata.regularTimeHome != null && matchdata.regularTimeGuest != null){
          regularTimeHome = matchdata.regularTimeHome;;
          regularTimeGuest = matchdata.regularTimeGuest;
        }
         var score = regularTimeHome+':'+regularTimeGuest;
      }
      /*if(matchdata.status == 'FIRST HALF'){
        
        if(matchdata.halfTimeHome == null && matchdata.halfTimeGuest == null){
          score = 'VS';
        }
        else if (matchdata.regularTimeHome != null && matchdata.regularTimeGuest != null){
          score = matchdata.regularTimeHome +':'+matchdata.regularTimeGuest;
        }
        else{
          score = halfTimeHome+':'+halfTimeGuest;
        }
        if(matchdata.regularTimeHome == null && matchdata.regularTimeGuest==null){
          var scoreClass = 'hidden';
        }
      }*/
      if(matchdata.status == 'FIRST HALF'){
        
        if((matchdata.regularTimeHome == null && matchdata.regularTimeGuest == null) && (matchdata.halfTimeHome == null && matchdata.halfTimeGuest == null)){
          score = '0:0';
        }
        else if(matchdata.halfTimeHome == null && matchdata.halfTimeGuest != null){
          score = '0:'+matchdata.halfTimeGuest;
        }
        else if(matchdata.halfTimeHome != null && matchdata.halfTimeGuest == null){
          score = matchdata.halfTimeHome + ':0';
        }
        else if(matchdata.regularTimeHome != null && matchdata.regularTimeGuest!=null){
          score = matchdata.regularTimeHome+':'+matchdata.regularTimeGuest;
        }
        else{
          score = matchdata.halfTimeHome+':'+matchdata.halfTimeGuest;
        }
        if(matchdata.regularTimeHome == null && matchdata.regularTimeGuest==null){
          var scoreClass = 'hidden';
        }
      }
      if(matchdata.status == 'SECOND HALF'){
        
        if((matchdata.regularTimeHome == null && matchdata.regularTimeGuest == null) && (matchdata.halfTimeHome == null && matchdata.halfTimeGuest == null)){
          score = '0:0';
        }
        else if(matchdata.halfTimeHome == null && matchdata.halfTimeGuest != null){
          score = '0:'+matchdata.halfTimeGuest;
        }
        else if(matchdata.halfTimeHome != null && matchdata.halfTimeGuest == null){
          score = matchdata.halfTimeHome + ':0';
        }
        else if(matchdata.regularTimeHome != null && matchdata.regularTimeGuest!=null){
          score = matchdata.regularTimeHome+':'+matchdata.regularTimeGuest;
        }
        else if(matchdata.regularTimeHome == null && matchdata.regularTimeGuest != null){
          score = matchdata.halfTimeHome+':'+matchdata.regularTimeGuest;
        }
        else if(matchdata.regularTimeHome != null && matchdata.regularTimeGuest==null){
          score = matchdata.regularTimeHome+':'+matchdata.halfTimeGuest;
        }
        else{
          score = matchdata.halfTimeHome+':'+matchdata.halfTimeGuest;
        }
        if(matchdata.regularTimeHome == null && matchdata.regularTimeGuest==null){
          var scoreClass = 'hidden';
        }
      }

      if((regularTimeHome == null && regularTimeGuest == null) && matchdata.halfTimeHome != null && matchdata.halfTimeGuest != null ){
        score = halfTimeHome+':'+halfTimeGuest;
      }
      if(match_id == Last_matchid && score == 'VS'){
        score = '0:0';
        halfTimeHome = 0;
        halfTimeGuest = 0;
      }

      if(matchdata.status == 'DEFERRED' || matchdata.status == 'ABORTED' || matchdata.status == 'INTERRUPTED'){ 
      score = 'VS'; 
      scoreClass = 'hidden';         
      }
  
      html += '<div class="team-score">'+score+'</div>';
      if(halfTimeHome != null && halfTimeGuest != null){
    	html += '<div class="team-time '+scoreClass+'">('+halfTimeHome+':'+halfTimeGuest+')</div>';
      }
      if(iSNP == true){
        html += '<div class="team-time">n.P.</div>';
      }else if(isnV == true){
        html += '<div class="team-time">n.V.</div>';
      }
      html += '</div>';
      html += '<div class="team-2">';
     
      if(matchdata.guestClub != null){
          var guest_team_name = matchdata.guestClub.name;
          if(guest_team_name == 'Gegner noch offen'){
            guest_team_name = gegner_noch_offen[lang];
          }
         html += '<div class="team-img">';
         html += '<img srcset="'+matchdata.guestClub.logo+'" alt="" loading="lazy">';
         html += '</div>';
         html += '<h2 class="team-name">'+guest_team_name+'</h2>';
      }
     
      
      html += '</div>';
      html += '</div>';
      
        // console.log(matchDay[mp].id,d1,d2);
        if((d1<=d2) ){
      
              html += '<div class="button-wrapper">';
                html += '<a href="/pages/matchcenter/'+matchDay[mp].id+'" class="button button--primary download">';
                  html += '<span>';
                    html += '<svg xmlns="http://www.w3.org/2000/svg" width="28.087" height="28.087" viewBox="0 0 28.087 28.087">';
                      html += '<path id="Icon_ionic-ios-football" data-name="Icon ionic-ios-football" d="M17.419,3.375A14.044,14.044,0,1,0,31.462,17.419,14.041,14.041,0,0,0,17.419,3.375Zm8.595,5.449A12.059,12.059,0,0,1,27.54,10.68a.247.247,0,0,1,.027.236l-.972,2.788a.268.268,0,0,1-.142.155L22.57,15.629a.272.272,0,0,1-.284-.041l-3.821-3.214a.277.277,0,0,1-.095-.209V7.905a.27.27,0,0,1,.122-.223L21.085,5.92a.266.266,0,0,1,.236-.034A12.3,12.3,0,0,1,26.014,8.824Zm-4.99,20.093a.249.249,0,0,1-.176.162,12.136,12.136,0,0,1-3.43.486,12.347,12.347,0,0,1-3.43-.486.28.28,0,0,1-.176-.162l-1.107-2.9a.283.283,0,0,1,.014-.223l1.506-2.856a.273.273,0,0,1,.236-.142h5.908a.265.265,0,0,1,.236.142l1.506,2.856a.283.283,0,0,1,.014.223Zm-4.551-21v4.26a.277.277,0,0,1-.095.209L12.551,15.6a.272.272,0,0,1-.284.041L8.385,13.867a.266.266,0,0,1-.142-.155L7.271,10.93a.264.264,0,0,1,.027-.236,12.241,12.241,0,0,1,6.225-4.78.266.266,0,0,1,.236.034L16.352,7.71A.223.223,0,0,1,16.473,7.919ZM5.38,17.966l2.437-2.107a.27.27,0,0,1,.29-.041l3.538,1.607a.27.27,0,0,1,.149.182l.986,3.869a.323.323,0,0,1-.02.2l-1.566,2.964a.263.263,0,0,1-.243.142l-3.106-.041a.282.282,0,0,1-.216-.108,12.067,12.067,0,0,1-2.343-6.441A.3.3,0,0,1,5.38,17.966ZM23.637,24.63l-1.56-2.957a.248.248,0,0,1-.02-.2l.986-3.869a.27.27,0,0,1,.149-.182l3.538-1.607a.284.284,0,0,1,.29.041l2.437,2.107a.273.273,0,0,1,.095.223,12.031,12.031,0,0,1-2.343,6.441.262.262,0,0,1-.216.108l-3.113.041A.3.3,0,0,1,23.637,24.63Z" transform="translate(-3.375 -3.375)" fill="#fff"></path>';
                      html += '</svg>';
                     //html += '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="20" viewBox="0 0 15 20">';
                      //html += '<path id="Icon_awesome-file-download" data-name="Icon awesome-file-download" d="M8.75,5.313V0H.938A.935.935,0,0,0,0,.938V19.063A.935.935,0,0,0,.938,20H14.063A.935.935,0,0,0,15,19.063V6.25H9.688A.94.94,0,0,1,8.75,5.313Zm2.986,8.256L7.97,17.307a.666.666,0,0,1-.939,0L3.264,13.569A.625.625,0,0,1,3.7,12.5H6.25V9.375a.625.625,0,0,1,.625-.625h1.25a.625.625,0,0,1,.625.625V12.5H11.3A.625.625,0,0,1,11.736,13.569ZM14.727,4.1,10.9.273A.937.937,0,0,0,10.238,0H10V5h5V4.762A.935.935,0,0,0,14.727,4.1Z" fill="#ae9357"/>';
                    //html += '</svg>';
                  html += '</span>';
                  //html += 'DOWNLOAD';
                html += '</a>';
              html += '</div>';
            
        }
      //}
      html += '</div>';
      html += '<div class="match-ticket-wrapper">';
        // if(mp > 0){
      if((matchdata.ticketsUrl != null && matchdata.ticketsUrl != "") && d1>d2 ){
        html += '<a href="'+matchdata.ticketsUrl+'" target="_blank" class="link link-ticket '+matchDay[mp].id+'">';
          html += '<span><svg xmlns="http://www.w3.org/2000/svg" width="30.604" height="20.402" viewBox="0 0 30.604 20.402">';
            html += '<path id="Icon_awesome-ticket-alt" data-name="Icon awesome-ticket-alt" d="M6.8,9.6h17V19.8H6.8Zm21.252,5.1a2.55,2.55,0,0,0,2.55,2.55v5.1a2.55,2.55,0,0,1-2.55,2.55H2.55A2.55,2.55,0,0,1,0,22.352v-5.1a2.55,2.55,0,0,0,0-5.1V7.05A2.55,2.55,0,0,1,2.55,4.5h25.5A2.55,2.55,0,0,1,30.6,7.05v5.1A2.55,2.55,0,0,0,28.053,14.7ZM25.5,9.176A1.275,1.275,0,0,0,24.228,7.9H6.376A1.275,1.275,0,0,0,5.1,9.176V20.227A1.275,1.275,0,0,0,6.376,21.5H24.228A1.275,1.275,0,0,0,25.5,20.227Z" transform="translate(0 -4.5)" fill="#fff"/>';
          html += '</svg></span>';
          html += 'TICKETS';
        html += '</a>';
    
        if(matchdata.showHospitality == 1 && d1>d2 && matchdata.homeClub.shortName == 'FCZ'){
          html += '<a href="/pages/hospitalityangebote" class="link link-hospitality">';
            html += '<span><svg xmlns="http://www.w3.org/2000/svg" width="14.063" height="25.001" viewBox="0 0 14.063 25.001">';
              html += '<path id="Icon_awesome-wine-glass" data-name="Icon awesome-wine-glass" d="M10.547,22.657H8.594V16.935a7.063,7.063,0,0,0,5.44-7.528L13.255.71A.775.775,0,0,0,12.488,0H1.575A.774.774,0,0,0,.809.71l-.779,8.7a7.063,7.063,0,0,0,5.44,7.528v5.722H3.516A1.953,1.953,0,0,0,1.563,24.61.391.391,0,0,0,1.953,25H12.11a.391.391,0,0,0,.391-.391A1.953,1.953,0,0,0,10.547,22.657Z" transform="translate(0)" fill="#fff"/>';
            html += '</svg></span>';
            html += 'HOSPITALITY';
          html += '</a>';
        }
      }
      if(matchdata.presaleStartDate != null){
        html += '<a href="" class="link link-start-date">';
          html += 'VORVERKAUF STARTET '+matchdata.presaleStartDate+' UHR';
        html += '</a>';
      }
      html += '</div>';
      html += '</div>';
    }

   var all_html = html + '' + html_next;   
   $('.spielplan-wrapper .next-match-inner').html(all_html);

    });

  
});


}
else {
  
  /*
  if(season_year == current_year){
    var url = API_URL + 'match-center/soccer-matches?filter[isUpcoming]=true&filter[type]='+gender+'&filter[season.name][]='+q;
  }else {    
    var url = API_URL + 'match-center/soccer-matches?filter[isUpcoming]=false&filter[type]='+gender+'&filter[season.name][]='+q;
  }*/

  var url = API_URL + 'match-center/soccer-matches?filter[type]='+gender+'&filter[season.name][]='+q;
  
  var settings = {
  "url": url,
  "method": "GET",
  "timeout": 0,
  "headers": {
    "Authorization": AUTH,
    "Content-Type": "application/json"
  }
};

$.ajax(settings).done(function (response) {
  console.log('three');
  var matchDay = response.data;
  var data = response.data;
  var html = '';
  var result = data.reduce(function (r, a) {
        r[monthyear(a.date)] = r[monthyear(a.date)] || [];
        r[monthyear(a.date)].push(a);
        return r;
    }, Object.create(null));
  
  /*if(typeof result.size === 'undefined'){
    html += '<div class="center">Übereinstimmung nicht verfügbar</div>';
  }*/
  if(jQuery.isEmptyObject(result)){
    html += '<div class="center"><h3 class="section-subtitle">Keine Spiele vorhanden.</h3></div>';
  }
  var d2 = new Date();  

  
  var Last_matchid = $('.spielplan-wrapper #last-men-match-id').attr("value");
  var Next_matchid = $('.spielplan-wrapper #next-men-match-id').attr("value"); 

  if(isWoman == true){
   var Last_matchid = $('.spielplan-wrapper #last-women-match-id').attr("value");
   var Next_matchid = $('.spielplan-wrapper #next-women-match-id').attr("value"); 
  }
  
  //console.log("fetch it",Last_matchid,Next_matchid,isWoman);
  const monthNames = ["Januar", "Februar", "März", "April", "Mai", "Juni",
    "Juli", "August", "September", "Oktober", "November", "Dezember"];
  
  var sortedEntries = Object.entries(result).sort((a, b) => {
    let [monthA, yearA] = a[0].split(' ');
    let [monthB, yearB] = b[0].split(' ');

    return yearA - yearB || monthNames.indexOf(monthA) - monthNames.indexOf(monthB);
  }); 
  
  $.each(sortedEntries, function (index, entry) {
    let key = entry[0];
    let matchDay = entry[1];
    
    html += '<h3 class="section-subtitle '+handleize(key)+'">'+key+'</h3>';
    
    for( var mp = 0; mp<matchDay.length; mp++){
      var iSNP = false;
      var isnV = false;
      var scoreClass = '';
      
      var matchdata = matchDay[mp];
      var regularTimeHome = matchdata.regularTimeHome;
      var regularTimeGuest = matchdata.regularTimeGuest;
      var halfTimeHome = matchdata.halfTimeHome;
      var halfTimeGuest = matchdata.halfTimeGuest;
      var newDate = matchdata.date.split(' ');
      var newTime = newDate[1].split(':');
      var date = newDate[0]+'T'+newDate[1]+'Z';
      var d1 = new Date(date);
      var match_id = matchDay[mp].id;
      
      if(match_id == Last_matchid){
        var match_class = "last-match-block";
      } else if(match_id == Next_matchid){
        var match_class = "next-match-block";
      } else {
        var match_class = "";
      }
       
      html += '<div class="match-block '+match_class+'" data-id="'+matchDay[mp].id+'">';
      html += '<div class="match-main-inner">';
     
      html += '<div class="match-date-wrapper">';     
      if(match_class == 'last-match-block'){
        html += '<div class="match-highlight">'+ last_game[lang] +'</div>';
      } else if(match_class == 'next-match-block'){
        html += '<div class="match-highlight">'+ next_game[lang] +'</div>';
      } else {} 
      html += '<div class="date">'+formatDateStringWithMonth(matchdata.date)+'</div>';
      html += '<div class="match-type">';
      if(matchdata.soccerLeague != null ){
        if(matchdata.soccerLeague.translations[0].name == 'Championship'){
          html += '<span class="match-Championship">'+championship[lang]+'</span>';
        }else if(matchdata.soccerLeague.translations[0].name == 'Test matches'){
          html += '<span class="match-Championship">'+test_matches[lang]+'</span>';
        }else if(matchdata.soccerLeague.translations[0].name == 'UEFA Frauen Champions League'){
          html += "<span class='match-Championship'>UEFA Women's Champions League</span>";
        }else{
            var soccerLeague_name = "";
            if(matchdata.soccerLeague.translations[0].name == 'Meisterschaft'){
              soccerLeague_name = championship[lang];
            } else if(matchdata.soccerLeague.translations[0].name == 'International') {
              soccerLeague_name = international[lang];
            } else if(matchdata.soccerLeague.translations[0].name == 'Schweizer Cup') {
              soccerLeague_name = swiss_cup[lang];
            } else if(matchdata.soccerLeague.translations[0].name == 'Testspiele') {
              soccerLeague_name = test_matches[lang];
            } else if(matchdata.soccerLeague.translations[0].name == 'Meisterschaft AWSL') {
              soccerLeague_name = meisterschaft_awsl[lang];
            }
            else {
              soccerLeague_name = matchdata.soccerLeague.translations[0].name;
            }
            html += '<span class="match-Championship">'+soccerLeague_name+'</span>' ;
        }
      }

      if(matchdata.soccerLeague != null && ((matchdata.soccerMatchDay != null && matchdata.soccerMatchDay != '') || (matchdata.deprecatedSoccerMatchDay != null && matchdata.deprecatedSoccerMatchDay!= ''))){
        html += '<span>, </span>';
      }
      
      if(matchdata.soccerMatchDay != null && matchdata.soccerMatchDay != ''){
        html += '<span class="match-matchDay">'+round[lang]+' '+matchdata.soccerMatchDay+'</span>';  
      }else if(matchdata.deprecatedSoccerMatchDay != null && matchdata.deprecatedSoccerMatchDay!= ''){
        html += '<span class="match-matchDay">'+round[lang]+' '+matchdata.deprecatedSoccerMatchDay+'</span>';
      }
      if(matchdata.isConfirmed == false){
        html += '<p class="match-not-confirmed">'+not_fixed[lang]+'</p>';
      }
      
// html += ' - '+matchdata.status      
      html += '</div>';
      html += '</div>';
      html += '<div class="match-wrapper-inner">';
      html += '<div class="team-1">';
      
      if(matchdata.homeClub != null){
        html += '<div class="team-img">';
        html += '<img srcset="'+matchdata.homeClub.logo+'" alt="" loading="lazy">';
        html += '</div>';  
        html += '<h2 class="team-name">'+matchdata.homeClub.name+'</h2>';
      }        
   
      html += '</div>';
      html += '<div class="team-score-wrapper">';
      if((regularTimeHome == null && regularTimeGuest == null) && (matchdata.status == 'NOT STARTED' || matchdata.status == 'ABORTED' || matchdata.status == '') ){
      	var score = 'VS';
      }
      else {
        if((matchdata.atForfeitHome != null && matchdata.atForfeitGuest != null) && (matchdata.atForfeitHome != 0 && matchdata.atForfeitGuest != 0) ){
          regularTimeHome = matchdata.atForfeitHome;
          regularTimeGuest = matchdata.atForfeitGuest;
          scoreClass = 'hidden';
        }else if((matchdata.penaltyShootoutHome != null && matchdata.penaltyShootoutGuest != null) && (matchdata.penaltyShootoutHome != 0 && matchdata.penaltyShootoutGuest != 0)){
          regularTimeHome = matchdata.penaltyShootoutHome;
          regularTimeGuest = matchdata.penaltyShootoutGuest;
          iSNP = true;
          scoreClass = 'hidden';
        }else if((matchdata.extraTimeHome != null && matchdata.extraTimeGuest != null) && (matchdata.extraTimeHome != 0 && matchdata.extraTimeGuest != 0)){
          regularTimeHome = matchdata.extraTimeHome;
          regularTimeGuest = matchdata.extraTimeGuest;
          isnV = true;
          scoreClass = 'hidden';
          // console.log('extra',matchDay[mp].id)
        }
        else if (matchdata.regularTimeHome != null && matchdata.regularTimeGuest != null){
          regularTimeHome = matchdata.regularTimeHome;;
          regularTimeGuest = matchdata.regularTimeGuest;
        }
         var score = regularTimeHome+':'+regularTimeGuest;
      }
      /*if(matchdata.status == 'FIRST HALF'){
        
        if(matchdata.halfTimeHome == null && matchdata.halfTimeGuest == null){
          score = 'VS';
        }
        else if (matchdata.regularTimeHome != null && matchdata.regularTimeGuest != null){
          score = matchdata.regularTimeHome +':'+matchdata.regularTimeGuest;
        }
        else{
          score = halfTimeHome+':'+halfTimeGuest;
        }
        if(matchdata.regularTimeHome == null && matchdata.regularTimeGuest==null){
          var scoreClass = 'hidden';
        }
      }*/
      if(matchdata.status == 'FIRST HALF'){
        
        if((matchdata.regularTimeHome == null && matchdata.regularTimeGuest == null) && (matchdata.halfTimeHome == null && matchdata.halfTimeGuest == null)){
          score = '0:0';
        }
        else if(matchdata.halfTimeHome == null && matchdata.halfTimeGuest != null){
          score = '0:'+matchdata.halfTimeGuest;
        }
        else if(matchdata.halfTimeHome != null && matchdata.halfTimeGuest == null){
          score = matchdata.halfTimeHome + ':0';
        }
        else if(matchdata.regularTimeHome != null && matchdata.regularTimeGuest!=null){
          score = matchdata.regularTimeHome+':'+matchdata.regularTimeGuest;
        }
        else{
          score = matchdata.halfTimeHome+':'+matchdata.halfTimeGuest;
        }
        if(matchdata.regularTimeHome == null && matchdata.regularTimeGuest==null){
          var scoreClass = 'hidden';
        }
      }
      if(matchdata.status == 'SECOND HALF'){
        
        if((matchdata.regularTimeHome == null && matchdata.regularTimeGuest == null) && (matchdata.halfTimeHome == null && matchdata.halfTimeGuest == null)){
          score = '0:0';
        }
        else if(matchdata.halfTimeHome == null && matchdata.halfTimeGuest != null){
          score = '0:'+matchdata.halfTimeGuest;
        }
        else if(matchdata.halfTimeHome != null && matchdata.halfTimeGuest == null){
          score = matchdata.halfTimeHome + ':0';
        }
        else if(matchdata.regularTimeHome != null && matchdata.regularTimeGuest!=null){
          score = matchdata.regularTimeHome+':'+matchdata.regularTimeGuest;
        }
        else if(matchdata.regularTimeHome == null && matchdata.regularTimeGuest != null){
          score = matchdata.halfTimeHome+':'+matchdata.regularTimeGuest;
        }
        else if(matchdata.regularTimeHome != null && matchdata.regularTimeGuest==null){
          score = matchdata.regularTimeHome+':'+matchdata.halfTimeGuest;
        }
        else{
          score = matchdata.halfTimeHome+':'+matchdata.halfTimeGuest;
        }
        if(matchdata.regularTimeHome == null && matchdata.regularTimeGuest==null){
          var scoreClass = 'hidden';
        }
      }

      if((regularTimeHome == null && regularTimeGuest == null) && matchdata.halfTimeHome != null && matchdata.halfTimeGuest != null ){
        score = halfTimeHome+':'+halfTimeGuest;
      }
      if(match_id == Last_matchid && score == 'VS'){
        score = '0:0';
        halfTimeHome = 0;
        halfTimeGuest = 0;
      }

      if(matchdata.status == 'DEFERRED' || matchdata.status == 'ABORTED' || matchdata.status == 'INTERRUPTED'){ 
      score = 'VS'; 
      scoreClass = 'hidden';         
      }
  
      html += '<div class="team-score">'+score+'</div>';
      if(halfTimeHome != null && halfTimeGuest != null){
    	html += '<div class="team-time '+scoreClass+'">('+halfTimeHome+':'+halfTimeGuest+')</div>';
      }
      if(iSNP == true){
        html += '<div class="team-time">n.P.</div>';
      }else if(isnV == true){
        html += '<div class="team-time">n.V.</div>';
      }
      html += '</div>';
      html += '<div class="team-2">';
     
      if(matchdata.guestClub != null){
        var guest_team_name = matchdata.guestClub.name;
        if(guest_team_name == 'Gegner noch offen'){
          guest_team_name = gegner_noch_offen[lang];
        }
         html += '<div class="team-img">';
         html += '<img srcset="'+matchdata.guestClub.logo+'" alt="" loading="lazy">';
         html += '</div>';
         html += '<h2 class="team-name">'+guest_team_name+'</h2>';
      }
     
      
      html += '</div>';
      html += '</div>';
      
    
        //console.log(matchDay[mp].id,d1,d2);
        if((d1<=d2) ){
      
              html += '<div class="button-wrapper">';
                html += '<a href="/pages/matchcenter/'+matchDay[mp].id+'" class="button button--primary download">';
                  html += '<span>';
                    html += '<svg xmlns="http://www.w3.org/2000/svg" width="28.087" height="28.087" viewBox="0 0 28.087 28.087">';
                      html += '<path id="Icon_ionic-ios-football" data-name="Icon ionic-ios-football" d="M17.419,3.375A14.044,14.044,0,1,0,31.462,17.419,14.041,14.041,0,0,0,17.419,3.375Zm8.595,5.449A12.059,12.059,0,0,1,27.54,10.68a.247.247,0,0,1,.027.236l-.972,2.788a.268.268,0,0,1-.142.155L22.57,15.629a.272.272,0,0,1-.284-.041l-3.821-3.214a.277.277,0,0,1-.095-.209V7.905a.27.27,0,0,1,.122-.223L21.085,5.92a.266.266,0,0,1,.236-.034A12.3,12.3,0,0,1,26.014,8.824Zm-4.99,20.093a.249.249,0,0,1-.176.162,12.136,12.136,0,0,1-3.43.486,12.347,12.347,0,0,1-3.43-.486.28.28,0,0,1-.176-.162l-1.107-2.9a.283.283,0,0,1,.014-.223l1.506-2.856a.273.273,0,0,1,.236-.142h5.908a.265.265,0,0,1,.236.142l1.506,2.856a.283.283,0,0,1,.014.223Zm-4.551-21v4.26a.277.277,0,0,1-.095.209L12.551,15.6a.272.272,0,0,1-.284.041L8.385,13.867a.266.266,0,0,1-.142-.155L7.271,10.93a.264.264,0,0,1,.027-.236,12.241,12.241,0,0,1,6.225-4.78.266.266,0,0,1,.236.034L16.352,7.71A.223.223,0,0,1,16.473,7.919ZM5.38,17.966l2.437-2.107a.27.27,0,0,1,.29-.041l3.538,1.607a.27.27,0,0,1,.149.182l.986,3.869a.323.323,0,0,1-.02.2l-1.566,2.964a.263.263,0,0,1-.243.142l-3.106-.041a.282.282,0,0,1-.216-.108,12.067,12.067,0,0,1-2.343-6.441A.3.3,0,0,1,5.38,17.966ZM23.637,24.63l-1.56-2.957a.248.248,0,0,1-.02-.2l.986-3.869a.27.27,0,0,1,.149-.182l3.538-1.607a.284.284,0,0,1,.29.041l2.437,2.107a.273.273,0,0,1,.095.223,12.031,12.031,0,0,1-2.343,6.441.262.262,0,0,1-.216.108l-3.113.041A.3.3,0,0,1,23.637,24.63Z" transform="translate(-3.375 -3.375)" fill="#fff"></path>';
                      html += '</svg>';
                     //html += '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="20" viewBox="0 0 15 20">';
                      //html += '<path id="Icon_awesome-file-download" data-name="Icon awesome-file-download" d="M8.75,5.313V0H.938A.935.935,0,0,0,0,.938V19.063A.935.935,0,0,0,.938,20H14.063A.935.935,0,0,0,15,19.063V6.25H9.688A.94.94,0,0,1,8.75,5.313Zm2.986,8.256L7.97,17.307a.666.666,0,0,1-.939,0L3.264,13.569A.625.625,0,0,1,3.7,12.5H6.25V9.375a.625.625,0,0,1,.625-.625h1.25a.625.625,0,0,1,.625.625V12.5H11.3A.625.625,0,0,1,11.736,13.569ZM14.727,4.1,10.9.273A.937.937,0,0,0,10.238,0H10V5h5V4.762A.935.935,0,0,0,14.727,4.1Z" fill="#ae9357"/>';
                    //html += '</svg>';
                  html += '</span>';
                  //html += 'DOWNLOAD';
                html += '</a>';
              html += '</div>';
            
        }
      //}
      html += '</div>';
      html += '<div class="match-ticket-wrapper">';
        // if(mp > 0){
      if((matchdata.ticketsUrl != null && matchdata.ticketsUrl != "") && d1>d2 ){
        html += '<a href="'+matchdata.ticketsUrl+'" target="_blank" class="link link-ticket '+matchDay[mp].id+'">';
          html += '<span><svg xmlns="http://www.w3.org/2000/svg" width="30.604" height="20.402" viewBox="0 0 30.604 20.402">';
            html += '<path id="Icon_awesome-ticket-alt" data-name="Icon awesome-ticket-alt" d="M6.8,9.6h17V19.8H6.8Zm21.252,5.1a2.55,2.55,0,0,0,2.55,2.55v5.1a2.55,2.55,0,0,1-2.55,2.55H2.55A2.55,2.55,0,0,1,0,22.352v-5.1a2.55,2.55,0,0,0,0-5.1V7.05A2.55,2.55,0,0,1,2.55,4.5h25.5A2.55,2.55,0,0,1,30.6,7.05v5.1A2.55,2.55,0,0,0,28.053,14.7ZM25.5,9.176A1.275,1.275,0,0,0,24.228,7.9H6.376A1.275,1.275,0,0,0,5.1,9.176V20.227A1.275,1.275,0,0,0,6.376,21.5H24.228A1.275,1.275,0,0,0,25.5,20.227Z" transform="translate(0 -4.5)" fill="#fff"/>';
          html += '</svg></span>';
          html += 'TICKETS';
        html += '</a>';
    
        if(matchdata.showHospitality == 1 && d1>d2 && matchdata.homeClub.shortName == 'FCZ'){
          html += '<a href="/pages/hospitalityangebote" class="link link-hospitality">';
            html += '<span><svg xmlns="http://www.w3.org/2000/svg" width="14.063" height="25.001" viewBox="0 0 14.063 25.001">';
              html += '<path id="Icon_awesome-wine-glass" data-name="Icon awesome-wine-glass" d="M10.547,22.657H8.594V16.935a7.063,7.063,0,0,0,5.44-7.528L13.255.71A.775.775,0,0,0,12.488,0H1.575A.774.774,0,0,0,.809.71l-.779,8.7a7.063,7.063,0,0,0,5.44,7.528v5.722H3.516A1.953,1.953,0,0,0,1.563,24.61.391.391,0,0,0,1.953,25H12.11a.391.391,0,0,0,.391-.391A1.953,1.953,0,0,0,10.547,22.657Z" transform="translate(0)" fill="#fff"/>';
            html += '</svg></span>';
            html += 'HOSPITALITY';
          html += '</a>';
        }
      }
      if(matchdata.presaleStartDate != null){
        html += '<a href="" class="link link-start-date">';
          html += 'VORVERKAUF STARTET '+matchdata.presaleStartDate+' UHR';
        html += '</a>';
      }
      html += '</div>';
      html += '</div>';
    }
  });
  
  $('.spielplan-wrapper .next-match-inner').html(html);
});
}


var season = $('.season-wrapper #id_season').val();

  var settings = {
    "url": API_URL+ 'match-center/soccer-leagues',
    "method": "GET",
    "timeout": 0,
    "headers": {
      "Accept": "application/vnd.api+json",
      "Authorization": AUTH,
      "Content-Type": "application/vnd.api+json"
    },
  };
  
  $.ajax(settings).done(function (response) {
    var data = response.data;
    if(data!=null){
      var html = ''
      if(isWoman == true){
        soccerLeagues = data.soccerLeaguesWomen;
      } else {
        soccerLeagues = data.soccerLeaguesMen;
      }
      for(let a=0; a<soccerLeagues.length; a++){
        var soccerLeague = soccerLeagues[a];
        var idLists = soccerLeague.idList;
        if(idLists != null){
          if(idLists.length > 0){
            for(let a=0; a<idLists.length;a++){
              var idList = idLists[a];
              if(idList.seasonName == season){
                // console.log(season,idList.seasonName)
                html += '<button class="button btn '+current_locale_code+'" data-value="'+idList.leagueId+'" style="order:'+soccerLeague.sortOrder+'">'+soccerLeague.soccerLeagueName+'</button>';  
              }
            }
          }
        }
      }

      $('.title-wrapper .filter-wrapper').append(html);

      var league = getParameterByName('league');
      
      if(league != null){
        $('.filter-wrapper .button').removeClass('active');
          $('.filter-wrapper .button[data-value="'+league+'"]').addClass('active');
      }
        
    }
  });    
});

$( document ).ajaxComplete(function() {
  // console.log('ajaxComplete');
  if($('.last-match-block').length > 0){
    var position = $('.last-match-block').offset().top - 150;
  
  	$("body, html").animate({
  		scrollTop: position
  	}, 2000 );
  }
});


$(document).on('change','.season-wrapper #id_season', function(){
	$(this).closest('form').submit();
});

$(document).ready(function(){
  $(document).on('click','.filter-wrapper .button',function(){
    let filterVal = $(this).data('value');
    
    let season = $('.season-wrapper #id_season').val(); //getParameterByName('season');
    
    window.location.href='?season='+season+'&league='+filterVal;

  });  
});